import React, { useState } from "react";
import { toPng } from "html-to-image";
import { IoMdDownload } from "react-icons/io";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const DownloadAsImage = ({ reportRef, title }) => {
  const downloadImage = () => {
    if (reportRef.current === null) return;

    toPng(reportRef.current, { cacheBust: true })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = `${title} report.png`;
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        alert("Could not generate image", err);
      });
  };

  return (
    <div className="position- top-0 end-0  m-1">
      <OverlayTrigger
        placement="top"
        delay={{ show: 100, hide: 200 }}
        overlay={<Tooltip id={`tooltip-1`}>Download {title} Report</Tooltip>}
      >
        <button
          className="position-relative btn btn-sm btn-outline-light "
          style={{
            borderRadius: "50%",
            width: "20px",
            height: "20px",
          }}
          onClick={downloadImage}
        >
          <IoMdDownload className="position-absolute top-50 start-50 translate-middle" />
        </button>
      </OverlayTrigger>
    </div>
  );
};

export default DownloadAsImage;
